module.exports = __webpack_public_path__ + "img/Girl_020009.54df43ea.png";